<template>
    <div class="swiper-section">
        <nav class="pagination" v-if="breakpointUpXxl">
            <a v-for="(item, index) in items" href="" @click.prevent="goToSlide(index)"
               :class="{active: swiperIndexSlide === index}">{{item.titre}}</a>
        </nav>
        <nav v-if="breakpointDownXl" class="pagination-mobile">
            <span class="icon-arrow-right left" @click="goPrev()"></span>
            <span class="title">{{slideLabel}}</span><span class="icon-arrow-right" @click="goNext()"></span>
        </nav>
        <div class="swiper-container swiper-brands-logos">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Swiper from "swiper";
    import {find} from "lodash";

    export default {
        props: {
            slug: {
                type: String,
                required: true,
            },
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                swiperInstance: null,
                swiperIndexSlide: 0,
                subSwiperArray: []
            };
        },
        computed: {
            breakpointDownXl() {
                return this.$root.breakpointDownXl;
            },
            breakpointUpXxl() {
                return this.$root.breakpointUpXxl;
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
            slideLabel() {
                return this.items[this.swiperIndexSlide].titre
            }
        },
        methods: {
            initSwiper() {

                let autoHeight = false;

                if (this.breakpointDownMd) {
                    autoHeight = true;
                }

                this.swiperInstance = new Swiper(".swiper-section." + this.slug + " .swiper-brands-logos", {
                    autoHeight: autoHeight,
                    effect: "fade",
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    on: {
                        slideChange: () => {
                            this.swiperIndexSlide = this.swiperInstance.activeIndex

                            this.stopAllSubSwiper()

                            this.checkActiveSlideForAutoPlay()

                        },
                    }
                })

                this.initSubSwiper()

            },
            goToSlide(index) {
                this.swiperInstance.slideTo(index)
            },
            goPrev() {
                this.swiperInstance.slidePrev()
            },
            goNext() {
                this.swiperInstance.slideNext()
            },
            initSubSwiper() {

                $(".swiper-section." + this.slug + " .swiper-brands-logos .swiper-container").each((index, el) => {

                    this.subSwiperArray[index] = new Swiper(el, {
                        effect: "fade",
                        nested: true,
                        speed: 600,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false
                        },
                    });
                })
                this.stopAllSubSwiper()
            },
            stopAllSubSwiper() {
                this.subSwiperArray.forEach(function (element) {
                    element.autoplay.stop()
                });
            },
            checkActiveSlideForAutoPlay() {
                let activeSlideEl = this.swiperInstance.slides[this.swiperInstance.activeIndex];

                if ($(activeSlideEl).find(".swiper-container").length) {

                    let activeSubSwiperEl = $(activeSlideEl).find(".swiper-container")[0]

                    let goodSubSwiperInstance = find(this.subSwiperArray, (o, index) => {
                        return o.el === activeSubSwiperEl
                    });

                    goodSubSwiperInstance.autoplay.start();

                }
            }
        },
        mounted() {
            this.initSwiper()
        },
        beforeDestroy() {
            this.swiperInstance.destroy()

            for (var key in this.subSwiperArray) {
                this.subSwiperArray[key].destroy()
            }

        }
    };
</script>
